import React, { type FC, useContext } from "react";
import { type HygieneNavigationProps } from "../generated-types";
import { Box, Flex, useBreakpointValue } from "~/foundation/Chakra";
import { Link } from "~/foundation/Components/Link";
import { useSitecoreContext } from "~/foundation/Jss";
import { type PageThemeBase } from "~/foundation/Theme/generated-types";
import { ColorThemeContext } from "~/foundation/Theme/ColorThemeContext";
import { withNavigationTheme } from "~/foundation/Theme/enhancers/withNavigationTheme";
import { LanguageNavigation } from "~/foundation/Components/LanguageNavigation";
import { GlobalContacts } from "~/foundation/Components/GlobalContacts";
import { UserWay } from "~/foundation/Components/UserWay";
import { type PageHideNavigationBase } from "~/foundation/Multisite/generated-types";

export const critical = true;

const HygieneNavigation: FC<HygieneNavigationProps> = ({ rendering }) => {
	const { sitecoreContext } = useSitecoreContext<PageThemeBase & PageHideNavigationBase>();
	const [theme] = useContext(ColorThemeContext);
	const languages = sitecoreContext?.custom.settings?.languages;
	const navItems = rendering.customData?.menuItems?.find(x => x.menuItemChildren)?.menuItemChildren?.filter(x => x.url);
	const isLargeViewport = useBreakpointValue({ base: false, lg: true }, { ssr: true });
	const isRtl = sitecoreContext.custom.settings.isRtl;

	const hideHeader = sitecoreContext?.route?.fields?.hideNavigation?.value;

	return (
		<>
			{(languages || navItems) &&
				<nav>
					<Flex
						flexFlow="row nowrap"
						justifyContent={["space-around", null, "flex-start"]}
						alignItems="center"
						sx={{
							".mobile-hygiene &": {
								justifyContent: "space-between",
							}
						}}
					>
						{!hideHeader && (
							<>
								<LanguageNavigation useTheme={true} />

								{navItems &&
									<Box ps="8">
										{navItems.map((menuItem, index) =>
											<Link
												key={index}
												to={menuItem.url!}
												size="sm"
												color={theme.colors.header.hygieneGlobalContacts}
												transitionDuration=".750s"
												transitionTimingFunction="ease-in-out"
												transitionProperty="color"
												fontSize="xs"
												fontWeight="400"
												lineHeight="base"
												_hover={{
													color: "primary.aramcoBlue",
												}}
												dataLayer={() => ({
													event: "GAevent",
													event_type: "click",
													event_name: "hygiene_navigation",
													type: "page",
													text: menuItem.title,
													url: menuItem.url
												})}
											>
												{menuItem.title}
											</Link>
										)}
									</Box>
								}
							</>
						)}

						{isLargeViewport && (
							<Box m={isRtl ? "0 auto 0 0" : "0 0 0 auto"}>
								<GlobalContacts />
							</Box>
						)}

						<UserWay />
					</Flex>
				</nav>
			}
		</>
	);
};

export default withNavigationTheme({ fallbackToPageTheme: true })(HygieneNavigation);